import { promotionsData } from "../../data/PromotionData"

export default function ModuleSpinSurprize({ closeModal }) {
  const promoData = promotionsData.find(
    (promo) => promo.title === "Saturday Spin Surprize"
  )

  function maskUsername(username) {
    if (!username || username.length < 5) return "---"

    const firstThree = username.slice(0, 3)
    const middleChar = username.charAt(5) // assuming you always want the 6th char
    const lastTwo = username.slice(-2)
    return `${firstThree}**${middleChar}***${lastTwo}`
  }

  const tableData = [
    {
      ranking: "1",
      username: "AN0BA001310",
      freeSpin: "40",
    },
    {
      ranking: "2",
      username: "AN0BA004913",
      freeSpin: "35",
    },
    {
      ranking: "3",
      username: "ANA0081854",
      freeSpin: "30",
    },
    {
      ranking: "4",
      username: "AN0BA002621",
      freeSpin: "25",
    },
    {
      ranking: "5",
      username: "AN0BA790853",
      freeSpin: "20",
    },
    {
      ranking: "6",
      username: "AN0BA797415",
      freeSpin: "10",
    },
    {
      ranking: "7",
      username: "AN0BA794187",
      freeSpin: "10",
    },
    {
      ranking: "8",
      username: "AN0BA864510",
      freeSpin: "10",
    },
    {
      ranking: "9",
      username: "AN0BA005033",
      freeSpin: "10",
    },
    {
      ranking: "10",
      username: "AN0BA823686",
      freeSpin: "10",
    },
    {
      ranking: "11",
      username: "AN0BA787582",
      freeSpin: "10",
    },
    {
      ranking: "12",
      username: "AN0BA696104",
      freeSpin: "10",
    },
    {
      ranking: "13",
      username: "AN0BA782614",
      freeSpin: "10",
    },
    {
      ranking: "14",
      username: "AN0BA004280",
      freeSpin: "10",
    },
    {
      ranking: "15",
      username: "AN0BA786876",
      freeSpin: "10",
    },
  ]

  return (
    <div className="promotion-module-pop-container">
      <div className="promotion-module-container">
        <button onClick={closeModal} className="promotion-close-btn">
          Close
        </button>
        <div className="promotion-module-main">
          <div className="promotion-leaderboard">
            <div className="promotion-module-banner">
              <img src={promoData.imgSrc} alt="Promotion Banner" />
              <div className="img-overlay"></div>
            </div>
            <table className="promotion-module-table">
              <thead>
                <tr>
                  <th>Ranking</th>
                  <th>Username</th>
                  <th>Free Spins</th>
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.ranking}</td>
                    <td>{row.username ? maskUsername(row.username) : "---"}</td>
                    <td>{row.freeSpin}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="promotion-module-cta">
            <span>Play to Earn Free Spins!</span>
            <a href="/slots/?provider=BNG">
              <button className="promotion-module-leaderboard-btn">
                Play Now
              </button>
            </a>
          </div>
        </div>
      </div>
    </div>
  )
}
